import { AuthContext } from 'components/AuthContextProvider'
import { useContext } from 'react'

export function useAuthContext() {
  return useContext(AuthContext)
}
